<template>
  <v-hover v-slot="{hover}">
    <v-card
      :elevation="hover ? activeElevation : defaultElevation"
      class="pa-0"
      @click="$emit('click')"
    >
      <slot />
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'TableShapeSelectableCard',
  props: {
    defaultElevation: {
      type: Number,
      default: 0
    },
    activeElevation: {
      type: Number,
      default: 2
    }
  },
  data () {
    return {}
  }
}
</script>